import { render, staticRenderFns } from "./ListDCPage.vue?vue&type=template&id=94039788&"
import script from "./ListDCPage.vue?vue&type=script&lang=js&"
export * from "./ListDCPage.vue?vue&type=script&lang=js&"
import style0 from "./ListDCPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports